import React, { PureComponent } from 'react';

class KeyTrigger extends PureComponent {
    render() {
        const { toggleKey, isKeyOpen } = this.props;
        return (
            <div className={ isKeyOpen ? 'keytrigger __active' : 'keytrigger' } onClick={(e) => toggleKey()}>What do the icons mean?</div>
        );
    }
}

export default KeyTrigger;


// WEBPACK FOOTER //
// ./src/Results/KeyTrigger.js